// src/pages/transferReceiveRecord/TransferReceiveRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchTransferReceiveRecord } from "./TransferReceiveRecordThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
};

const transferReceiveRecordSlice = createSlice({
  name: "transferReceiveRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferReceiveRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTransferReceiveRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchTransferReceiveRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = transferReceiveRecordSlice.actions;
export default transferReceiveRecordSlice.reducer;
